import React, { useState } from 'react';
import { Table, Input, Button, Tooltip, Card, Tag } from 'antd';
import { SearchOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import EmployeeResponse from '../../model/Employee.model';

interface EmployeeListTableProps {
  employeeList: EmployeeResponse[];
  onSuccess: () => Promise<void>;
}

const EmployeeListTable: React.FC<EmployeeListTableProps> = ({
  employeeList,
  onSuccess,
}) => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  // Lọc danh sách ngay khi người dùng nhập vào ô tìm kiếm
  const filteredEmployees = employeeList.filter((employee) =>
    [employee.name, employee.contactInfo, employee.user.email].some((field) =>
      field.toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  // Hàm chuyển đổi tên vai trò sang định dạng hiển thị
  const translateRoleName = (roleName: string) => {
    switch (roleName) {
      case 'ROLE_ADMIN':
        return 'Quản trị viên';
      case 'ROLE_EMPLOYEE':
        return 'Nhân viên';
      default:
        return roleName;
    }
  };

  const columns = [
    {
      title: 'STT',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) =>
        (currentPage - 1) * pageSize + index + 1,
    },
    { title: 'Tên nhân viên', dataIndex: 'name', key: 'name' },
    { title: 'Số điện thoại', dataIndex: 'contactInfo', key: 'contactInfo' },
    { title: 'Email', dataIndex: ['user', 'email'], key: 'email' },
    {
      title: 'Vai trò',
      key: 'roles',
      render: (_: any, record: EmployeeResponse) => (
        <>
          {record.user.roles && record.user.roles.length > 0 ? (
            record.user.roles.map((role) => (
              <Tag color={role.id === 1 ? 'blue' : 'green'} key={role.id}>
                {translateRoleName(role.name)}
              </Tag>
            ))
          ) : (
            <Tag color="default">Nhân viên</Tag>
          )}
        </>
      ),
    },
    {
      title: 'Hành động',
      key: 'actions',
      render: (_: any, record: EmployeeResponse) => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <Tooltip title="Xem chi tiết">
            <Button
              icon={<EyeOutlined />}
              onClick={() => navigate(`/employee/${record.id}`)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Card>
      <h2
        style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '16px' }}
      >
        Danh sách nhân viên
      </h2>
      <Input
        placeholder="Tìm kiếm theo tên, số điện thoại hoặc email..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        prefix={<SearchOutlined />}
        style={{ marginBottom: 16 }}
      />
      <Table
        columns={columns}
        dataSource={filteredEmployees.map((employee, index) => ({
          ...employee,
          index,
        }))}
        rowKey="id"
        pagination={{
          pageSize: 10,
          current: currentPage,
          onChange: setCurrentPage,
          showSizeChanger: false,
        }}
      />
    </Card>
  );
};

export default EmployeeListTable;
